import { render, staticRenderFns } from "./nshop-statistics-mode.vue?vue&type=template&id=037c6183&scoped=true&"
import script from "./nshop-statistics-mode.vue?vue&type=script&lang=js&"
export * from "./nshop-statistics-mode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c6183",
  null
  
)

export default component.exports